import React, { useState, useEffect } from "react"
import axios from "axios"

const EnquiryForm = props => {
  const [SuccessMessage, setSuccessMessage] = useState("hide")
  const [FormContainer, setFormContainer] = useState("show")
  const [ErrorMessage, setErrorMessage] = useState("")
  const [modalTitle, setmodalTitle] = useState("Enquire Now")
  const [Name, setName] = useState("")
  const [Email, setEmail] = useState("")
  const [Phone, setPhone] = useState("")
  const [Seats, setSeats] = useState("")
  const [BookFrom, setBookFrom] = useState("")
  const [Button, SetButton] = useState(false)

  const handleSubmit = e => {
    e.preventDefault()

    if (
      Name !== "" &&
      Email !== "" &&
      Phone !== "" &&
      Seats !== "" &&
      BookFrom !== ""
    ) {
      var myDate = BookFrom
      myDate = myDate.split("-")
      var newDate = myDate[1] + "/" + myDate[2] + "/" + myDate[0]
      var datefrom = new Date(newDate).getTime()

      SetButton(true)
      setErrorMessage("")
      var myHeaders = new Headers()
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded")
      var urlencoded = new URLSearchParams()
      urlencoded.append("name", Name)
      urlencoded.append("source", "API")
      urlencoded.append("date", datefrom)
      urlencoded.append("email", Email)
      urlencoded.append("phone", Phone)
      urlencoded.append("spaceId", props.spaceId)
      urlencoded.append("numberOfSeats", Seats)
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      }
      fetch("https://gofloaters.firebaseapp.com/spaces/enquiry", requestOptions)
        .then(response => {
          response.text()
          setSuccessMessage("show")
          setFormContainer("hide")
          setName("")
          setEmail("")
          setPhone("")
          setSeats("")
          setBookFrom("")
          setErrorMessage("")
          setmodalTitle("")
          SetButton(false)
        })
        .then(result => console.log(result))
        .catch(error => console.log("error", error))
    } else {
      setErrorMessage("Please fill all the mandatory Fields")
    }
  }
  return (
    <div className="enquiry-container">
      <div className="social-proof d-none d-md-block">
        <h3>Why Choose GoFloaters?</h3>
        <div className="social-proof-content">
          <div className="proof-item">
            <h4>Trusted by 100+ Companies</h4>
            <p>Join the growing community of companies who trust GoFloaters for their workspace needs</p>
            <div className="company-logos">
              <div className="logo-grid">
                <img
                  src="https://assets.gofloaters.com/clients/newset/chargebee.png" alt="Chargebee"
                  style={{ height: "20px" }}
                ></img>
                <img
                  src="https://assets.gofloaters.com/clients/newset/bira.png" alt="Bira91"
                  style={{ height: "25px" }}
                ></img>
                <img
                  src="https://assets.gofloaters.com/clients/newset/infeedo.png" alt="Infeedo"
                  style={{ height: "20px" }}
                ></img>
                <img
                  src="https://assets.gofloaters.com/clients/newset/wingify.png" alt="Wingify"
                  style={{ height: "20px" }}
                ></img>
                <img
                  src="https://assets.gofloaters.com/clients/decalthlon.png" alt="Decalthlon"
                  style={{ height: "20px" }}
                ></img>
                <img
                  src="https://assets.gofloaters.com/clients/newset/cactus.png" alt="Cactus"
                  style={{ height: "20px" }}
                ></img>
                <img
                  src="https://assets.gofloaters.com/clients/newset/gain-credit.png" alt="Gain Credit"
                  style={{ height: "20px" }}
                ></img>
                <img
                  src="https://assets.gofloaters.com/clients/newset/acko.png" alt="ACKO"
                  style={{ height: "20px" }}
                ></img>
              </div>
            </div>
          </div>
          <div className="proof-item">
            <h4>5000+ Verified Spaces</h4>
            <p>Every space is verified to ensure the best quality for our users</p>
          </div>
          <div className="proof-item">
            <h4>Over 20,000 seats delivered</h4>
            <p>Over the last 5 years we have delivered 20,000+ seats to startups and large companies across India</p>
          </div>
          <div className="proof-item">
            <h4>Exceptional Support</h4>
            <p>Our dedicated team ensures a smooth experience from booking to checkout</p>
          </div>
        </div>
      </div>
      <div className="form-section">
        <form className="compact-form">
          <div className={"formContainer " + FormContainer}>
            <div className="form-group">
              <label htmlFor="Name">Your Name *</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={Name}
                onChange={e => {
                  setName(e.currentTarget.value)
                  setErrorMessage("")
                }}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email address *</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={Email}
                onChange={e => {
                  setEmail(e.currentTarget.value)
                  setErrorMessage("")
                }}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="Phone">Phone *</label>
              <input
                type="tel"
                name="phone"
                className="form-control"
                value={Phone}
                onChange={e => {
                  setPhone(e.currentTarget.value)
                  setErrorMessage("")
                }}
                required
              />
            </div>
            <div className="form-row">
              <div className="form-group col-6">
                <label htmlFor="seats">No.of Seats *</label>
                <input
                  type="number"
                  name="seats"
                  className="form-control"
                  value={Seats}
                  onChange={e => {
                    setSeats(e.currentTarget.value)
                    setErrorMessage("")
                  }}
                  min="1"
                  required
                />
              </div>
              <div className="form-group col-6">
                <label htmlFor="bookfrom">Book From *</label>
                <input
                  type="date"
                  name="bookfrom"
                  className="form-control"
                  value={BookFrom}
                  onChange={e => {
                    setBookFrom(e.currentTarget.value)
                    setErrorMessage("")
                  }}
                  min="1"
                  required
                />
              </div>
            </div>
            <button
              onClick={handleSubmit}
              disabled={Button}
              className="btn btn-default w-100"
              id="monthly-office-enquire-now"
            >
              Submit
            </button>
          </div>
          <p style={{ color: "red", fontWeight: "bold" }}>{ErrorMessage}</p>
          <div className={"text-center message " + SuccessMessage}>
            <p>
              Thanks for your interest! Our space partner has been notified and
              you shall hear from them shortly.
            </p>
          </div>
        </form>
      </div>
      <style jsx>{`
        .enquiry-container {
          display: flex;
        }
        .social-proof,
        .form-section {
          flex: 1;
        }
        .social-proof {
          padding: 2rem;
          background: #f8f9fa;
          border-radius: 8px;
        }
        .social-proof h3 {
          margin-bottom: 1.5rem;
          color: #333;
        }
        .proof-item {
          margin-bottom: 1.5rem;
        }
        .proof-item h4 {
          color: #2c5282;
          font-size: 1.1rem;
          margin-bottom: 0.5rem;
        }
        .proof-item p {
          color: #4a5568;
          font-size: 0.95rem;
        }
        .company-logos {
          margin-top: 1.5rem;
        }
        .logo-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          grid-template-rows: repeat(2, 1fr);
          gap: 1.5rem;
          align-items: center;
        }
        .logo-grid img {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
        .compact-form {
          max-width: 100%;
          padding: 1.5rem;
          background: white;
          border-radius: 8px;
        }
        .form-group {
          margin-bottom: 1rem;
        }
        .form-group label {
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 0.25rem;
        }
        .form-control {
          padding: 0.5rem;
        }
        .form-row {
          display: flex;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        @media (max-width: 768px) {
          .enquiry-container {
            flex-direction: column;
          }
          .compact-form {
            padding: 1rem;
          }
          .form-row {
            flex-direction: column;
            gap: 1rem;
          }
          .form-row .form-group {
            width: 100%;
          }
        }
      `}</style>
    </div>
  )
}

export default EnquiryForm
